module.exports = __webpack_public_path__ + "static/media/cristalero.09a31124.jpg";